var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCilSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0258 36.6927L36.5825 29.2494L30.8573 26.8841C32.7636 24.1732 33.7849 20.9391 33.7812 17.625C33.7812 8.71639 26.5336 1.46875 17.625 1.46875C8.71639 1.46875 1.46875 8.71639 1.46875 17.625C1.46875 26.5336 8.71639 33.7812 17.625 33.7812C20.9679 33.7851 24.2288 32.7461 26.9533 30.8091L29.3125 36.5189L36.7555 43.9625C37.2328 44.4399 37.7995 44.8186 38.4232 45.077C39.0469 45.3353 39.7154 45.4683 40.3905 45.4683C41.0656 45.4683 41.734 45.3354 42.3577 45.0771C42.9815 44.8187 43.5482 44.4401 44.0256 43.9628C44.5029 43.4854 44.8816 42.9187 45.14 42.295C45.3983 41.6713 45.5313 41.0029 45.5313 40.3278C45.5314 39.6527 45.3984 38.9842 45.1401 38.3605C44.8818 37.7368 44.5031 37.1701 44.0258 36.6927ZM4.40625 17.625C4.40625 10.3363 10.3363 4.40625 17.625 4.40625C24.9137 4.40625 30.8438 10.3363 30.8438 17.625C30.8438 24.9137 24.9137 30.8437 17.625 30.8437C10.3363 30.8437 4.40625 24.9137 4.40625 17.625ZM41.9485 41.8854C41.535 42.298 40.9747 42.5297 40.3906 42.5297C39.8065 42.5297 39.2462 42.298 38.8327 41.8854L31.8037 34.8564L29.6103 29.5473L34.9195 31.7407L41.9487 38.7698C42.3612 39.1833 42.5928 39.7435 42.5928 40.3276C42.5928 40.9117 42.3611 41.472 41.9485 41.8854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilSearch);
export default __webpack_public_path__ + "static/media/cil_search.e928666cc469bfcc7af4c4a0b299cfbc.svg";
export { ForwardRef as ReactComponent };